module.exports = __webpack_public_path__ + "img/18.problem_shower.6eba5d31.svg";